<template>
   <AppLayout>
      <template #main>
         <div class="py-24 sm:py-32 mt-6">
            <div class="mx-auto max-w-8xl px-6 lg:px-20 items-center">
               <div class="flex flex-col mt-8">
                  <!-- Meet the Team -->
                  <div
                     class="flex flex-wrap justify-center text-center mb-24"
                  >
                     <div class="w-full lg:w-6/12 px-4">
                        <!-- Header -->
                        <h1
                           class="text-gray-900 text-4xl font-bold mb-8 uppercase"
                        >
                           {{ $t('about.banner_title') }}
                        </h1>
                     </div>
                  </div>


                  <!-- Team Members -->
                  <div class="flex flex-wrap justify-center space-x-4">
                     <TeamMemberItem
                        v-for="(teamMember) in teamMembers"
                        :key="teamMember.id"
                        :team-member="teamMember"
                     />
                  </div>
               </div>
            </div>
         </div>

         <div class="grid">
            <img
               class="col-start-1 row-start-1 h-full w-full object-fit"
               src="/images/home/splash_section_v2.png"
               role="presentation"
            >
            <div
               class="grid grid-cols-1 lg:grid-cols-3 col-start-1 row-start-1 place-items-center p-12 sm:p-24 gap-y-6 lg:gap-x-12 mt-6 sm:mt-0"
            >
               <div
                  v-motion-slide-visible-once-left
                  class="content-center"
               >
                  <h3
                     class="text-3xl font-bold text-white mb-4 uppercase"
                  >
                     {{ aboutUsBlocks[0].title }}
                  </h3>
                  <div
                     class="text-base font-normal text-white"
                     v-html="aboutUsBlocks[0].subtitle"
                  />
               </div>
               <div
                  v-motion-slide-visible-once-bottom
                  class=""
               >
                  <h3
                     class="text-3xl font-bold text-white mb-4 uppercase"
                  >
                     {{ aboutUsBlocks[1].title }}
                  </h3>
                  <div
                     class="text-base font-normal text-white"
                     v-html="aboutUsBlocks[1].subtitle"
                  />
               </div>
               <div
                  v-motion-slide-visible-once-right
                  class=""
               >
                  <h3
                     class="text-3xl font-bold text-white mb-4 uppercase"
                  >
                     {{ aboutUsBlocks[2].title }}
                  </h3>
                  <div
                     class="text-base font-normal text-white"
                     v-html="aboutUsBlocks[2].subtitle"
                  />
               </div>
            </div>
         </div>
         <div class="py-32">
            <SponsorsSection />
         </div>
      </template>
   </AppLayout>
</template>

<script setup>
   import AppLayout from '@/Layouts/AppLayout.vue';
   import TeamMemberItem from '@/Components/TeamMember.vue';
   import { ref } from 'vue';
   import SponsorsSection from '@/Components/SponsorsSection.vue';

   const props = defineProps({
      pageBlocks: Object,
   });

   const teamMembers = ref(props.pageBlocks.teamMembers.data);

   const aboutUsBlocks = ref(props.pageBlocks.text.data);
   const sponsorsBlocks = ref(props.pageBlocks.images.data);

</script>
